import { Component, Input } from '@angular/core';

export enum MenuIconTypes {
  MEASURES,
  EVENTS,
  MESSAGES,
  HOME,
  MY_MEASURES,
  LOGOUT,
  HELP,
  PROFILE,
  EDOCUMENTS,
  EDIARY
}

@Component({
  selector: 'bepatient-dynamic-menu-icon',
  templateUrl: './dynamic-menu-icon.component.html',
  styleUrls: ['./dynamic-menu-icon.component.scss'],
  standalone: false
})
export class DynamicMenuIconComponent {
  @Input() icon: MenuIconTypes;
  @Input() color: string;

  menuIconTypes = MenuIconTypes;
}
